/**
 * exercise-row.js
 */

import React from 'react';
import { parseISO } from 'date-fns';
import { useTranslation } from 'react-i18next';
import { Types } from 'utils/constants';
import useRecordStore from 'contexts/record-store';
import { UserContext } from 'contexts/user/user-context';
import ExerciseRowHandler from './exercise-row-handler';
import ExerciseRowSupervisor from './exercise-row-supervisor';
import ExerciseRowTrainer from './exercise-row-trainer';


const ExerciseRow = React.memo(function (props) {
  const { id } = props;
  const { t } = useTranslation('general');
  const recordStore = useRecordStore();
  const { user } = React.useContext(UserContext);
  const exerciseRecord = recordStore.useRecord(Types.Record.EXERCISE, id).ornull;
  const eventRecord = recordStore.useRecord(Types.Record.EVENT, exerciseRecord.get().eventId).ornull;

  if (!exerciseRecord || !eventRecord) return null;


  // event
  const event = eventRecord.get();
  const now = new Date();
  const eventDate = parseISO(event.date);
  const isFuture = eventDate > now;

  // exercise
  const exercise = exerciseRecord.get();
  const workMode = exercise.workMode;
  const workModeName = Types.WorkMode.getName(t, workMode);


  const rowProps = {
    ...props,
    event,
    exercise,
    workMode,
    workModeName,
    isFuture,
  };


  return (
    <div>
      {user.role.isHandler &&
      <ExerciseRowHandler {...rowProps} />}

      {user.role.isSupervisor &&
      <ExerciseRowSupervisor {...rowProps} />}

      {user.role.isTrainer &&
      <ExerciseRowTrainer {...rowProps} />}
    </div>
  )
}, (prev, next) => {
  return (
    prev.id === next.id
    && prev.isSelected === next.isSelected
    && prev.isSelectDisabled === next.isSelectDisabled
    && prev.isRecordTrackingRelevant === next.isRecordTrackingRelevant
  );
});

export default ExerciseRow;